import React from 'react'
import { isNotEmptyArray, isNumeric } from 'src/services/validationService'
import { formatterPeso } from 'src/utils/utils'
import { Row, Col } from 'react-bootstrap';

const TotalAmountReceiptValidationForm = ({ setAllowSaveAmountValidation, expedientesSeleccionados, selectedExpedientAssociated, totalAmountReceipts, importe, receipts }) => {

    const amountsShowValidation = (totalReceiptAmount, importe) => {
        const total = Number(totalReceiptAmount);
        const totalImporte = Number(importe);

        if (!isNaN(total) && !isNaN(totalImporte)) {
            const resultCondition = total.toFixed(2) === totalImporte.toFixed(2);
            setAllowSaveAmountValidation(resultCondition);
            return resultCondition;
        }
        setAllowSaveAmountValidation(false);
        return false;
    };

    const isValidTotalAmountReceipts = amountsShowValidation(totalAmountReceipts, importe);

    return (
        <>
            {(isNotEmptyArray(expedientesSeleccionados) || isNotEmptyArray(selectedExpedientAssociated)) &&
                <Row className='align-right mt-5 border border-1 rounded px-2 pt-4 my-5 mx-2' >
                    <Col className='col-md-8 text-right mx-0 mb-2 py-2'>
                        <h6>Importe total de Orden de Pago:</h6>
                    </Col>
                    <Col className={`col-md-4 text-right border border-1 rounded mx-0 mb-2 py-2 ${isValidTotalAmountReceipts ? 'bg-success-light' : 'bg-warning-light'} `}>
                        {isNaN(importe) ? '' : formatterPeso.format(importe)}
                    </Col>
                    {receipts !== undefined &&
                        <>
                            <Col className='col-md-8 text-right mx-0 mb-1 py-2'>
                                <h6>Importe Total de Recibos Seleccionados:</h6>
                            </Col>
                            <Col className={`col-md-4 text-right border border-1 rounded mx-0 mb-1 py-2 ${isValidTotalAmountReceipts ? 'bg-success-light' : 'bg-warning-light'} `}>
                                {formatterPeso.format(totalAmountReceipts)}
                            </Col>
                        </>
                    }
                    {isNotEmptyArray(receipts) && (!isValidTotalAmountReceipts &&
                        <Col className='offset-md-8 md-4 text-right alert alert-danger my-2'>
                            El total de la orden de pago y los recibos debe coincidir
                        </Col>
                    )}
                </Row>
            }
        </>
    )
}

export default TotalAmountReceiptValidationForm;